module.exports = __webpack_public_path__ + "static/media/logo.1090473d.svg";